/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { fetchLastReservations } from '../core/_requests'
import moment from 'moment'

const LastReservations = () => {
  const token = localStorage.getItem('@auth/token')
  const [lastReservations, setLastReservations] = useState<any[]>([])

  const fetchReservations = async () => {
    try {
      const response = await fetchLastReservations(token ?? '')
      if (response && response['hydra:member']) {
        setLastReservations(response['hydra:member'])
      }
    } catch (error) {
      console.error('Error fetching last reservations:', error)
    }
  }

  useEffect(() => {
    fetchReservations()
  }, [])

  const getStatusClass = (status: string) => {
    switch (status.toLowerCase()) {
      case 'approved':
        return 'badge-light-success'
      case 'pending':
        return 'badge-light-warning'
      case 'cancelled':
        return 'badge-light-danger'
      default:
        return 'badge-light-info'
    }
  }

  const formatDate = (date: string) => {
    if (!date) return 'N/A'
    return moment.utc(date).format('DD/MM/YYYY')
  }

  const formatTime = (time: string) => {
    if (!time) return 'N/A'
    return moment.utc(time).format('HH:mm')
  }

  const formatCreatedDate = (date: string) => {
    if (!date) return 'N/A'
    return moment.utc(date).format('DD/MM/YYYY HH:mm')
  }
  return (
    <div className='col-xl-4'>
      <div className='card card-xl-stretch mb-5 mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold text-dark'>New Added Bookings</span>
            <span className='text-muted mt-2 fw-semibold fs-7'>Recent bookings</span>
          </h3>
        </div>

        <div className='card-body py-3'>
          <div className='table-responsive'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold text-muted'>
                  <th className='min-w-150px'>User</th>

                  <th className='min-w-100px'>Date</th>
                  <th className='min-w-80px'>Time</th>
                  <th className='min-w-100px'>Area</th>
                  <th className='min-w-100px'>Status</th>
                  <th className='min-w-120px'>Created</th>
                </tr>
              </thead>
              <tbody>
                {lastReservations.length > 0 ? (
                  lastReservations.map((booking, index) => (
                    <tr key={index}>
                      <td>
                        <span className='text-dark fw-bold fs-6'>
                          {booking.user?.fullname || 'Unknown User'}
                        </span>
                      </td>

                      <td>
                        <span className='text-muted fw-semibold fs-7'>
                          {formatDate(booking.date)}
                        </span>
                      </td>
                      <td>
                        <span className='text-muted fw-semibold fs-7'>
                          {formatTime(booking.startTime)} - {formatTime(booking.endTime)}
                        </span>
                      </td>
                      <td>
                        <span className='text-muted fw-semibold fs-7'>
                          {booking.area?.title || (booking.trainer ? 'With Trainer' : 'N/A')}
                        </span>
                      </td>
                      <td>
                        <span className={`badge ${getStatusClass(booking.status || '')}`}>
                          {booking.status || 'Unknown'}
                        </span>
                      </td>
                      <td>
                        <span className='text-muted fw-semibold fs-7'>
                          {formatCreatedDate(booking.createdAt)}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className='text-center'>
                      <span className='text-muted fw-semibold fs-7'>No reservations found</span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LastReservations
